import { Factory } from 'core'
import { createContext } from 'react'

export const FactoryContext = createContext<Factory | null>(null)
